import { VariationDisplay } from '@gonfalon/flag-variations/VariationDisplay';
import type { Variation } from '@gonfalon/flags/types';
import { Message } from '@gonfalon/messages/Message';
import { msg } from '@gonfalon/messages/msg';
import { Dialog, Heading, IconButton, Modal, ModalOverlay } from '@launchpad-ui/components';

import styles from './imagePreviewModal.module.css';

type ImagePreviewModalProps = {
  isOpen: boolean;
  variation?: Variation;
  variationIndex?: number;
  src?: string;
  onOpenChange: (isOpen: boolean) => void;
};

export const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({
  isOpen,
  variation,
  variationIndex,
  src,
  onOpenChange,
}) => {
  const shouldShowModal = isOpen && !!src;
  return (
    <ModalOverlay isOpen={shouldShowModal} onOpenChange={onOpenChange}>
      <Modal size="large">
        <Dialog>
          <Heading slot="title" className={styles.imagePreviewModalHeading}>
            {variation && typeof variationIndex === 'number' ? (
              <VariationDisplay
                className={styles.variationDisplay}
                variation={variation}
                variationIndex={variationIndex}
              />
            ) : (
              <span className={styles.variationDisplay}>
                <Message id="experiments.imagePreviewDialog.heading" />
              </span>
            )}
            <IconButton
              slot="close"
              icon="cancel"
              aria-label={msg('experiments.imagePreviewDialog.closeLabel')}
              variant="minimal"
            />
          </Heading>
          <div className={styles.imageWrapper}>
            <img className={styles.image} src={src} alt={msg('experiments.imagePreviewDialog.previewAlt')} />
          </div>
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
};
